export class CartModel {
	constructor() {}

	validateOrder(res) {
		if (!res.order_id) throw new Error("Не удалось получить order_id!");

		return {
			id: res.order_id,
			amount: res.summ || 0,
			discount: res.discount || 0,
			commission: res.commission || 0,
			activeCarts: res.active_carts || {},
		};
	}
}
